import { notify } from 'notify';

import { rest_request } from './_partials/_rest.js';

(function () {
	const forms = document.querySelectorAll(`form[data-email_subscribe]`);

	if (forms.length === 0) {
		return;
	}

	function submit(e) {
		e.preventDefault();

		const form = e.currentTarget,
			input = form.querySelector(`input[type="email"]`),
			button = form.querySelector(`button[type="submit"]`);

		input.disabled = true;
		button.disabled = true;

		rest_request(`subscribe`, {
			method: `POST`,
			data: {
				email: input.value,
			},
		})
			.then((response) => {
				notify(`success`, response);
			})
			.catch((error) => {
				notify(`error`, error.message || error);
			})
			.then(() => {
				input.disabled = false;
				button.disabled = false;
			});
	}

	function setup() {
		for (let i = 0; i < forms.length; i++) {
			forms[i].addEventListener(`submit`, submit);
		}
	}

	setup();
})();
